import { hocHook } from "../../../@hoc/hoc-hook";
import { Home } from "./home";

export default hocHook(Home);
